export const ExtractPhoneNumbers = (str: string) => {
  const re = /(?:[-+() ]*\d){10,13}/gm;
  const res = (str.match(re) || []).map(function(s) {
    return s.trim();
  });
  return res;
};
